import { useContext } from 'react';
import { MessageContext } from '../components/wrappers/MessageProvider';

const useMessages = () => useContext(MessageContext);

export default useMessages;
